import PillTab from './PillTab';

export default PillTab;
